export default "__VITE_ASSET__EMXD0hW___"